import React from 'react';
import { Filter, TrendingUp, Clock, Calendar } from 'lucide-react';

const FilterBar = ({ activeFilter, onFilterChange, activeSort, onSortChange, type = 'hunt' }) => {
  const filters = {
    hunt: [
      { value: 'all', label: 'All Time', icon: <Calendar className="w-3 h-3" /> },
      { value: 'today', label: 'Today', icon: <Clock className="w-3 h-3" /> },
      { value: 'week', label: 'This Week', icon: <Calendar className="w-3 h-3" /> },
      { value: 'month', label: 'This Month', icon: <Calendar className="w-3 h-3" /> }
    ],
    stories: [
      { value: 'all', label: 'All Time', icon: <Calendar className="w-3 h-3" /> },
      { value: 'today', label: 'Today', icon: <Clock className="w-3 h-3" /> },
      { value: 'week', label: 'This Week', icon: <Calendar className="w-3 h-3" /> }
    ],
    domains: [
      { value: 'all', label: 'All', icon: <Calendar className="w-3 h-3" /> },
      { value: 'available', label: 'Available', icon: <Filter className="w-3 h-3" /> },
      { value: 'owned', label: 'Owned', icon: <Filter className="w-3 h-3" /> }
    ]
  };

  const sortOptions = {
    hunt: [
      { value: 'votes', label: 'Top Rated', icon: <TrendingUp className="w-3 h-3" /> },
      { value: 'recent', label: 'Recent', icon: <Clock className="w-3 h-3" /> },
      { value: 'comments', label: 'Most Discussed', icon: <Calendar className="w-3 h-3" /> }
    ],
    stories: [
      { value: 'support', label: 'Most Supported', icon: <TrendingUp className="w-3 h-3" /> },
      { value: 'recent', label: 'Recent', icon: <Clock className="w-3 h-3" /> }
    ],
    domains: [
      { value: 'price-high', label: 'Price: High to Low', icon: <TrendingUp className="w-3 h-3" /> },
      { value: 'price-low', label: 'Price: Low to High', icon: <TrendingUp className="w-3 h-3" /> },
      { value: 'recent', label: 'Recently Added', icon: <Clock className="w-3 h-3" /> }
    ]
  };

  const currentFilters = filters[type] || filters.hunt;
  const currentSorts = sortOptions[type] || sortOptions.hunt;

  return (
    <div className="flex flex-col sm:flex-row gap-4 mb-6 p-4 bg-slate-900/50 border border-slate-800 rounded-lg">
      {/* Filters */}
      <div className="flex-1">
        <div className="text-xs text-slate-500 font-bold uppercase mb-2 flex items-center gap-2">
          <Filter className="w-3 h-3" />
          Filter
        </div>
        <div className="flex flex-wrap gap-2">
          {currentFilters.map(filter => (
            <button
              key={filter.value}
              onClick={() => onFilterChange(filter.value)}
              className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium transition ${
                activeFilter === filter.value
                  ? 'bg-amber-500 text-slate-900'
                  : 'bg-slate-800 text-slate-400 hover:bg-slate-700 hover:text-white'
              }`}
            >
              {filter.icon}
              {filter.label}
            </button>
          ))}
        </div>
      </div>

      {/* Sort */}
      <div className="flex-1">
        <div className="text-xs text-slate-500 font-bold uppercase mb-2 flex items-center gap-2">
          <TrendingUp className="w-3 h-3" />
          Sort By
        </div>
        <div className="flex flex-wrap gap-2">
          {currentSorts.map(sort => (
            <button
              key={sort.value}
              onClick={() => onSortChange(sort.value)}
              className={`flex items-center gap-2 px-3 py-1.5 rounded-lg text-xs font-medium transition ${
                activeSort === sort.value
                  ? 'bg-amber-500 text-slate-900'
                  : 'bg-slate-800 text-slate-400 hover:bg-slate-700 hover:text-white'
              }`}
            >
              {sort.icon}
              {sort.label}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
